const addCalendarEvent = {
  async presentEventCreatingDialog() {
    return { action: 'CANCELED' }
  },
  async presentEventEditingDialog() {
    return { action: 'CANCELED' }
  },
  async checkPermissions() {
    return 'unavailable'
  },
  async requestPermissions() {
    return 'unavailable'
  },
  // Some versions expose `permissions` / `PERMISSIONS`; keep these to avoid crashes.
  permissions: {},
  PERMISSIONS: {},
}

module.exports = {
  __esModule: true,
  default: addCalendarEvent,
  ...addCalendarEvent,
}

